import { LocalStorage, LocalStorageKeys } from 'helpers/localStorage';
import { ANDROID_AND_IOS_APP_SOURCE } from 'modules/missions/helpers/appDetection';

const appSourceStorage = new LocalStorage<string, null>(
  LocalStorageKeys.AppSource,
  null
);

// The app marks only the entry url, and a navigation or a reload no longer
// carries it, so the marker is kept the first time it is seen.
export const captureAppSource = (): void => {
  const source = new URLSearchParams(window.location.search).get('source');

  if (source === ANDROID_AND_IOS_APP_SOURCE) appSourceStorage.replace(source);
};

export const getAppSource = (): string | null => appSourceStorage.get();
